<template>
  <div id="blog">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn v-if="editIndex === -1" fab absolute right class="mr-3 pf-btn-fab" :href="'#/blog/add'" to="/blog/add">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn v-else fab absolute left @click="backTolisting" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-if="isListEmpty" class="text-center">
        <img src="static/NoBlogs.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No Blog(s) Found !! </b></h4>
    </v-container>
    <v-container fluid class="pt-0 pl-0" v-if="editIndex === -1 && blogList.length > 0">
      <draggable v-model="blogList" class="layout wrap row pb-4" handle=".handle" @start="drag=true" @end="drag=false;" forceFallback="false">
      <v-container class="-border" v-for="eachItem of blogList" :key="eachItem.id">
        <v-layout>
          <v-flex class="xs12 sm10">
            <h5 class="pf-sub-head mb-2 custom-title">
              <b>{{ eachItem.title }}</b>
              <span v-if="typeof eachItem.approved !== 'undefined' && !eachItem.approved" class="pf-pending-approval-label">Pending approval</span>
              <!-- <span class="pl-2 pr-2 pt-1 pb-1 pf-text-white pf-font-12 border-radius-15" :class="{ 'pf-bg-green': eachItem.status.toLowerCase() === 'publish', 'pf-bg-pink': eachItem.status.toLowerCase() !== 'publish' }">{{ eachItem.status }}</span> -->
            </h5>
            <i>{{ formatDate(eachItem.updatedAt, 'MMM DD, YYYY') }} </i>
          </v-flex>
          <v-flex class="xs12 sm2 text-md-right">
            <v-btn icon class="ma-0 handle">
              <v-icon size="22" color="grey darken-2">open_with</v-icon>
            </v-btn>
            <v-btn icon class="ma-0" @click="editItem(eachItem)"> <!-- :href="`#/blog/edit/${eachItem.id}`"> -->
              <v-icon size="22" color="grey darken-2">edit</v-icon>
            </v-btn>
            <v-btn icon class="ma-0">
              <v-icon v-on:click="deleteItem(eachItem)" size="22" color="grey darken-2">delete_outline</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex v-html="eachItem.content" class="text-xs-justify pt-3"></v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm6 md4>
            <v-card falt tile v-if="eachItem.image && eachItem.image.filename">
            <v-layout class="wrap pt-1 pr-1 xs12 text-xs-center">
              <v-flex xs12 pl-1>
                <div>
                  <img
                    :src="eachItem.image.original_url"
                    :lazy-src="eachItem.image.original_url"
                    width="100%"
                    >
                </div>
              </v-flex>
            </v-layout>
          </v-card>
          </v-flex>
        </v-layout>
        <v-divider class="mt-4"></v-divider>
      </v-container>
      </draggable>
    </v-container>
    <v-form v-if="editIndex != -1" ref="formEdit">
      <v-container class="-border" >
        <v-layout wrap>
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex class="xs12 sm6">
            <v-text-field label="Blog Title" v-model.trim ="editData.title" class="required pr-4 pl-4" :rules="[rules.required]" @input="changedData"></v-text-field>
          </v-flex>
          <v-flex class="xs12 sm6">
            <!-- <v-select label="Status" @change="changedData" v-model="editData.status" :items="statuses" class="pr-4 pl-4 required"></v-select> -->
          </v-flex>
           <v-layout wrap pl-2 pr-2>
            <v-flex class="xs12 sm6 pl-4 pf-sub-head custom-title" wrap>Blog Content</v-flex>
          </v-layout>
          <v-flex xs12>
            <div id="blogTextEditor" >
              <v-container grid-list-xl fluid mt-0>
                <v-layout row wrap>
                  <v-flex sm12>
                    <v-layout class="flex-row flex-space-between mb-2 ml-1 mr-1">
                      <div class="pf-font-14 pf-text-teal flex-start pf-width-100p">Maximum number of words: {{ BlogSettings.word_count ? BlogSettings.word_count : 1500 }}</div>
                      <div class="pf-font-14 flex-end pf-width-100p" :class="{ 'pf-text-red': currentWordCount > (BlogSettings.word_count || 1500), 'pf-text-teal': currentWordCount <= (BlogSettings.word_count || 1500) }">Number of words: {{ currentWordCount }}</div>
                    </v-layout>
                    <editor :options="editorOption" :init="init" :api-key="apikey" v-model="editData.content" @onKeyUp="changedData" @onPaste="changedData" @onInit="changedData" />
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-flex>
          <!-- <v-layout wrap pl-2 pr-2>
            <v-flex class="xs12 sm6 pl-4 pf-sub-head custom-title" wrap>Short Description</v-flex>
          </v-layout>
          <v-flex class="xs12">
            <div class="blogTextEditorShort" >
              <v-container grid-list-xl fluid mt-0>
                <v-layout row wrap>
                  <v-flex sm12>
                    <editor :options="editorOption.shortDescription" :init="initmeta" :api-key="apikey" v-model="editData.excerpt" @input="changedData" />
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-flex> -->
          <!-- <v-flex class="xs12 sm6">
            <v-combobox class="pr-4 pl-4" @change="changedData" v-model="editData.categories" :items="BlogCategory" label="Categories - hit enter to add or choose from most used" @keyup.enter="addCategory" multiple deletable-chips small-chips></v-combobox>
          </v-flex> -->
          <v-flex class="xs12 sm6">
            <v-select class="pr-4 pl-4" @change="changedData" v-model="editData.tags" :items="BlogSettings.tags" label="Tags - choose from the list" multiple deletable-chips small-chips no-data-text="No tags available"></v-select>
          </v-flex>
          <!-- <v-flex class="xs12 sm6">
            <upload-btn title="Featured Image"></upload-btn>
          </v-flex> -->
        </v-layout>

        <!-- <v-layout wrap class="mt-4">
          <v-flex xs12 sm12 class="pr-4 pl-4">
            <h5 class="text-uppercase font-weight-bold">Search Engine Options</h5>
          </v-flex>
          <v-flex class="xs12 sm6">
            <v-text-field label="Title" v-model="editData.seo.title" class="pr-4 pl-4" @input="changedData"></v-text-field>
          </v-flex>
          <v-flex class="xs12 sm6">
            <v-text-field label="Slug" v-model="getBlogSlug" class="pr-4 pl-4" @input="changedData"></v-text-field>
          </v-flex>
          <v-flex class="xs12 sm6">
            <v-combobox class="pr-4 pl-4" @change="changedData" v-model="editData.seo.keywords" :items="keywords" label="Keywords - hit enter to add new" @keyup.enter="addKeyword" multiple deletable-chips small-chips></v-combobox>
          </v-flex>
          <v-flex class="xs12">
            <div class="blogTextEditorShort" >
              <v-container grid-list-xl fluid>
                <v-layout row wrap>
                  <v-flex sm12>
                    <editor :options="editorOption.metaDescription" :init="initmeta" :api-key="apikey" v-model="editData.seo.metaDescription" @input="changedData" />
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-flex>
        </v-layout> -->
          <!-- image add seciton starting-->
        <v-layout wrap pl-2 pr-2 class="mt-4 imageAdd">
          <v-flex class="xs12 sm6 md7 pl-4 pt-4 pf-sub-head mb-3 custom-title" wrap>Featured Image
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-btn
                    class="pf-btn-text-white pf-bg-green"
                    @click="addBlogImage()"
                  >
                    Upload
                    <v-icon size="22" class="ml-2">camera_alt</v-icon>
                  </v-btn>
                </span>
                </template>
                <span>Add new image</span>
              </v-tooltip>
          </v-flex>
        </v-layout>
        <!-- image show div start-->
        <v-layout wrap class="mt-4 imageDiv" pl-2 pr-2>
          <v-flex xs12 sm6 md4 pl-4>
            <v-card falt tile v-if="editData.image && editData.image.filename">
            <v-layout class="wrap pt-1 pr-1 xs12 text-xs-center">
              <v-flex xs12 pl-1>
                <div>
                  <img
                    :src="editableImageUrl"
                    :lazy-src="editableImageUrl"
                    width="100%"
                    >
                </div>
              </v-flex>
            </v-layout>
          </v-card>
          </v-flex>
        </v-layout>
        <!-- image show div end-->
        <v-layout>
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router store config */
import $ from 'jquery';
import swal from 'sweetalert2';
import { getCollection, update, remove, sortList, formatDate, updateSortList, stringToSlug, checkWPToken, requestToWPPF, uploadFile } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import Editor from '@tinymce/tinymce-vue';
import UploadButton from 'vuetify-upload-button';

import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-lists/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-vue-richtexteditor/styles/material.css';

import Vue from 'vue';
import { RichTextEditorPlugin, Toolbar, Image,  Link, HtmlEditor, QuickToolbar, NodeSelection } from '@syncfusion/ej2-vue-richtexteditor';

Vue.use(RichTextEditorPlugin);

// This lists all the blogs for the user and allow to edit them.
export default {
  name: 'BlogList',
  components: {
    draggable,
    'editor': Editor
  },
  data: (vm) => ({
    entity: 'Blog',
    roleEntity: 'Account',
    isListEmpty: false,
    config: config,
    editorOption: {
      'initial-value': 'Add text here..',
      metaDescription: {
        placeholder: 'Add meta description here..'
      },
      shortDescription: {
        placeholder: 'Add pm2short description here..'
      }
    },
    apikey: config.tinymceEditorKey,
    init: {
      height: 500,
      selector: 'blogTextEditor',
      paste_data_images: true,
      file_picker_types: 'image',
      images_upload_handler: function (blobInfo, success, failure) {
        let postUrl = 'File';
        let extraParams = {
          type: 'Blog'
        };
        extraParams[vm.roleEntity.toLowerCase()] = session.user().human[vm.roleEntity.toLowerCase()].id;

        uploadFile(postUrl, blobInfo.blob(), 'POST', extraParams)
          .then(function (res) {
            success(config.uploadPath + res.$data.webPath);
          })
          .catch(function (err) {
            failure('HTTP Error: ' + err.message);
          });
      },
      menubar: true,
      plugins: ['advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount emoticons'],
      toolbar:
           'undo redo | bold italic backcolor | fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | forecolor backcolor removeformat | pagebreak | charmap emoticons | preview | insertfile image media template link anchor codesample | ltr rtl'
    },
    initmeta: {
      height: 200,
      menubar: false,
      plugins: ['wordcount emoticons'],
      toolbar:
           'undo redo | bold italic backcolor | fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | forecolor backcolor removeformat | charmap emoticons | link anchor | ltr rtl'
    },
    selectedData: false,
    editIndex: -1,
    blog: {
      title: '',
      description: ''
    },
    editableImageUrl: '',
    rules: {
      required: value => !!value || 'Field is required.',
    },
    editData: {},
    isUploadDone: false,
    // statuses: ['publish', 'draft', 'pending', 'private'],
    // keywords: [],
    currentWordCount: 0,
  }),
  provide: {
    richtexteditor: [Toolbar, Image, Link, HtmlEditor, QuickToolbar]
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Account', 'Agency', 'Child']),
    blogList: {
      get () {
        return store.state.Blog;
      },
      set (value) {
        if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
          updateSortList(this.entity, value, 'Agency', session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
        } else {
          updateSortList(this.entity, value, this.roleEntity, session.getSession().adminUser ? session.getSession().user.human[this.roleEntity.toLowerCase()].id : 'Me');
        }
        store.commit('setBlog', value);
      }
    },
    /* getBlogSlug: {
      get () {
        return stringToSlug(this.editData.title);
      },
      set (value) {
        this.editData.seo.slug = value;
      }
    }, */
    /* BlogCategory: {
      get () {
        return store.state.BlogCategory;
      },
      set (value) {
        store.commit('setBlogCategory', value);
      }
    }, */
    BlogSettings: {
      get () {
        return store.state.BlogSettings;
      },
      set (value) {
        store.commit('setBlogSettings', value);
      }
    }
  },
  async created () {
    this.roleEntity = session.role() === 'child' ? 'Child' : this.roleEntity;
    await this.initialize();
    await this.removeContentEditable();
    if (this.blogList.length) { this.feedSelects() }
  },
  methods: {
    async removeContentEditable () {
      this.$nextTick(() => {
        let editable_elements = document.querySelectorAll('[contenteditable=true]');
        for (let i = 0; i < editable_elements.length; i++) editable_elements[i].setAttribute('contenteditable', false);
      });
    },
    // @vuese
    // Used to fetch blog categories and tags from wordpress.
    async feedSelects () {
      if (!Object.keys(this.BlogSettings).length) {
        let where = {
          '$or': [{ is_super_admin: true }]
        };
        if (this[this.roleEntity].default_agency) {
          where['$or'].push({ _id: this[this.roleEntity].default_agency });
        }
        let attributes = 'blog_settings,is_super_admin';
        let { error, data } = await getCollection('Agency', true, 0, '', where, attributes);
        if (error) {
          console.log(error);
        } else {
          /* Get the settings from admin by default */
          let adminIndex = data.findIndex(x => x.is_super_admin);
          let blogSettings = {};
          if (adminIndex > -1 && data[adminIndex].blog_settings && Object.keys(data[adminIndex].blog_settings).length) {
            blogSettings.word_count = data[adminIndex].blog_settings.word_count ? data[adminIndex].blog_settings.word_count : 1500;
            blogSettings.tags = data[adminIndex].blog_settings.tags ? data[adminIndex].blog_settings.tags : [];
          } else {
            /* Set a default value */
            blogSettings = {
              word_count: 1500,
              tags: []
            };
          }
          /* Overwrite the word count if set by agency */
          let defaultAgencyIndex = data.findIndex(x => x.id === this[this.roleEntity].default_agency);
          if (defaultAgencyIndex > -1 && data[defaultAgencyIndex].blog_settings && data[defaultAgencyIndex].blog_settings.word_count) {
            blogSettings.word_count = data[defaultAgencyIndex].blog_settings.word_count ? data[defaultAgencyIndex].blog_settings.word_count : blogSettings.word_count;
          }
          this.BlogSettings = blogSettings;
        }
      }
    },
    // @vuese
    // Used to go back to the blog listing page from blog edit mode
    backTolisting () {
      this.isUploadDone = false;
      this.editIndex = -1;
      this.selectedData = false;
      window.getApp.$emit('pageSubHeader', '');
    },
    // @vuese
    // Used to fetch the blog list if no exists.
    async initialize () {
      if (!this.blogList.length) {
        let sessionUser = session.getSession();
        let where = {};
        if (sessionUser.adminUser) {
          if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
            where.agency = sessionUser.user.human.agency;
          } else {
            where[this.roleEntity.toLowerCase()] = sessionUser.user.human[this.roleEntity.toLowerCase()].id;
          }
        }
        let { error, data } = await getCollection(this.entity, true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
              this.blogList = sortList(this.entity, data, 'Agency', sessionUser.adminUser ? sessionUser.user.human.agency : 'Me');
            } else {
              this.blogList = sortList(this.entity, data, this.roleEntity, sessionUser.adminUser ? sessionUser.user.human[this.roleEntity.toLowerCase()].id : 'Me');
            }
          } else {
            this.isListEmpty = true;
          }
        }
      }
    },
    // @vuese
    // Used to setup the edit item while clicking on edit
    editItem (item) {
      window.getApp.$emit('pageSubHeader', 'Edit');
      this.editIndex = this.blogList.indexOf(item);
      this.editData = JSON.parse(JSON.stringify(item));
      if (this.editData.image) {
        this.editableImageUrl = this.editData.image.original_url;
      }

    },
    // @vuese
    // Used to show the buttons on changing the edit form data.
    changedData (event, editor) {
      this.selectedData = true;

      /* Update the word count if blog content */
      if (editor && editor.plugins && editor.plugins.wordcount) {
        this.currentWordCount = editor.plugins.wordcount.body.getWordCount();
      }
    },
    // @vuese
    // Used to hide the form buttons on edit mode
    hideButtons () {
      this.isUploadDone = false;
      this.selectedData = false;
    },
    // @vuese
    // Used to format the mongo date string
    // @arg Mongo date string, the output format
    formatDate (dateString, format) {
      return formatDate(dateString, format);
    },
    // @vuese
    // Used to delete the blog item
    // @arg The item going to be deleted
    deleteItem (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove(this.entity, item.id);
            if (error) {
              console.log('error', error);
              this.snackbar = {
                show: true,
                color: 'red',
                text: 'Something went wrong, please try again.'
              };
            } else {
              const index = this.blogList.indexOf(item);
              this.blogList.splice(index, 1);
              if (this.blogList.length === 0) this.isListEmpty = true;
              let entity = ['agency', 'caseworker'].indexOf(session.role()) > -1 ? 'Agency' : this.roleEntity;
              let deletedBlogItem = this[entity].blog.find(blog => blog.blog === item.id);
              this[entity].blog.splice(this[entity].blog.indexOf(deletedBlogItem), 1);
              swal.fire(
                'Deleted!',
                'The blog with title "' + item.title + '" has been deleted.',
                'success'
              );
            }
          })();
        }
      });
    },
    // @vuese
    // Used to add a new category on edit mode
    /* addCategory () {
      this.BlogCategory = [...this.BlogCategory, ...this.editData.categories];
    }, */
    // @vuese
    // Used to add a new tag on edit mode
    addTag () {
      this.BlogSettings.tags = [...this.BlogSettings.tags, ...this.editData.tags];
    },
    // @vuese
    // Used to add a new seo keyword on edit mode
    /* addKeyword () {
      this.keywords = [...this.keywords, ...this.editData.seo.keywords];
    }, */
    // @vuese
    // Used to save the edited blog.
    async save () {
      this.selectedData = false;
      if (!this.editData.title.length) {
        this.selectedData = true;
        swal.fire({
          type: 'warning',
          title: 'Title is required.',
          text: 'Please add title before saving!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        return;

      } else if (!this.editData.content.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
        this.selectedData = true;
        swal.fire({
          type: 'warning',
          title: 'Content is required.',
          text: 'Please add the blog content to save',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        return;
      } else if (this.currentWordCount > (this.BlogSettings.word_count || 1500)) {
        swal.fire({
          type: 'warning',
          title: 'Content is too lengthy.',
          text: `The blog content should not exceed ${(this.BlogSettings.word_count || 1500)} words`,
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK',
          onClose: () => {
            this.selectedData = true;
          }
        });
        return;
      }
      if (this.$refs.formEdit.validate() && this.editIndex > -1) {
        this.selectedData = false;
        if (this.isUploadDone && this.editData.image && this.editData.image.original_url) {
          this.editData.image.thumb_url = this.editData.image.original_url.replace(/original/gi, 'thumb');
          this.editData.image.webview_url = this.editData.image.original_url.replace(/original/gi, 'webview');
        }
        let { error, data, status } = await update(this.entity, this.editData, this.editData.id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Something went wrong, please try again.'
          };
        } else {
          this.blogList[this.editIndex] = data;
          this.loading = false;
          this.isUploadDone = false;
          swal.fire({
            type: 'success',
            title: 'Blog updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.editIndex = -1;
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    },
    addBlogImage () {
      const client = global.filestack.init(config.filestack.client);
      const humanId = session.user().human.id;
      const options = {
        fromSources: ['local_file_system'],
        maxFiles: 1,
        accept: ['image/*'],
        uploadInBackground: false,
        transformations: {
          crop: { aspectRatio: 300 / 228 }
        },
        storeTo: {
          location: 'S3',
          path: '/' + config.s3Domain + '/' + humanId + '/blogs/images/original/',
          access: 'public'
        },
        onFileSelected (file) {
          let filenameArr = file.filename.split('.');
          let ext = filenameArr.pop();
          let filename = filenameArr.join('.');
          filename = filename.replace(/[^0-9a-z]/gi, '');
          return { name: filename + '_' + (new Date().getTime()) + '.' + ext };
        },
        onUploadDone: (response) => {
          if (!this.editData.image) {
            this.editData.image = {
              thumb_url: '',
              webview_url: '',
              original_url: '',
              s3: true,
              filename: '',
            };
          }
          this.editData.image.original_url = response.filesUploaded[0].key;
          this.isUploadDone = true;
          this.selectedData = true;
          this.editableImageUrl = response.filesUploaded[0].url;
          this.editData.image.filename = this.editData.image.original_url.split('/').pop();
          swal.fire({
            type: 'success',
            title: 'Blog image uploaded successfully',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
        }
      };
      client.picker(options).open();
    }
  }
};
</script>
<style scoped>
.letrimmgbtns {
  display: flex;
  justify-content: flex-end;
}

#blog >>> .e-richtexteditor .e-rte-toolbar {
  z-index: auto !important;
}

#blog >>> .e-linkheader, #blog >>> .imgUrl {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Blog/list.vue